export interface ComparisonPublicSituationRequest {
    task_id: string;
}

/**
 * 对比文献公开情况响应
 */
export type ComparisonPublicSituationResponse = {
    patent_id: string;
    related_para: string;
    pn: string;
    public_score: number;
}[];

/**
 * 对比文献公开情况 API
 */
export interface ComparisonPublicSituationApi {
    /**
     * 获取对比文献公开情况/新颖性评述
     * @param params 请求参数
     * @returns 对比文献公开情况/新颖性评述
     */
    getComparisonPublicSituation(params: ComparisonPublicSituationRequest): Promise<ComparisonPublicSituationResponse>;
}

export const ComparisonPublicSituationApi = Symbol('ComparisonPublicSituationApi');

/**
 * 新颖性报告结论 API
 */
export interface NoveltyReportConclusionRequest {
    task_id: string;
}

/**
 * 新颖性报告结论响应
 */
export type NoveltyReportConclusionResponse = boolean;

/**
 * 新颖性报告结论 API
 */
export interface NoveltyReportConclusionApi {
    /**
     * 获取新颖性报告结论
     * @param params 请求参数
     * @returns 新颖性报告结论
     */
    getNoveltyReportConclusion(params: NoveltyReportConclusionRequest): Promise<NoveltyReportConclusionResponse>;
}

export const NoveltyReportConclusionApi = Symbol.for('NoveltyReportConclusionApi');
